import { orderBy } from "lodash";
import keyBy from "lodash.keyby";
import { createSelector } from "reselect";

import { TeamMemberStatus } from "@fitness-app/data-models";

import { type AppStore } from "../../..";

const getTrainerTeamData = (state: AppStore) => state.team;
const getUserData = (state: AppStore) => state.user.profile;

export const getAssignedRegularTrainers = createSelector(
  getTrainerTeamData,
  (trainerTeam): Record<string, string[]> => {
    if (!trainerTeam.trainers?.length) {
      return {};
    }

    return Object.fromEntries(
      trainerTeam.trainers.map((trainer) => [
        trainer.id,
        trainer.assignedTrainers?.map((assigned) => assigned.trainer?.id)?.flat() || [],
      ]),
    );
  },
);

export const getTrainersTeam = createSelector([getTrainerTeamData], (trainerTeam) => [
  ...orderBy(trainerTeam.trainers ?? [], (item) => item.assignedTrainees.length, "desc").sort((a, b) => {
    if (a.status === TeamMemberStatus.INACTIVE && b.status === TeamMemberStatus.ACTIVE) {
      return 1;
    }
    if (a.status === TeamMemberStatus.ACTIVE && b.status === TeamMemberStatus.INACTIVE) {
      return -1;
    }

    if (a.status === TeamMemberStatus.INVITED && b.status === TeamMemberStatus.INACTIVE) {
      return -1;
    }

    return 0;
  }),
]);

export const getTrainersTeamById = createSelector([getTrainerTeamData], (trainerTeam) =>
  keyBy(trainerTeam.trainers ?? [], "id"),
);

export const getTraineeToTrainerMap = createSelector(
  [getTrainerTeamData, getUserData],
  (trainerTeam, user): Record<string, string> => {
    if (!user) {
      return {};
    }

    const traineeToTrainerMap: Record<string, string> = {};

    trainerTeam.trainers?.forEach((trainer) => {
      trainer.assignedTrainees?.forEach((trainee) => {
        traineeToTrainerMap[trainee.id] = trainer.id;
      });
    });

    return traineeToTrainerMap;
  },
);
